// extracted by mini-css-extract-plugin
module.exports = {"image":"fS-z","loaded":"gS-z","placeholder":"hS-z"};